import * as SessionActionTypes from 'app/modules/session/constants';
import isDocumentHidden from 'lib/isDocumentHidden';
import getTrimmedUrl from 'lib/getTrimmedUrl';

const {
  CUSTOMER_TYPING_STATE_UPDATED,
  SESSION_CREATE_ERROR,
  SESSION_CREATE_SUCCESS,
  SESSION_UPDATE_SUCCESS,
  SESSION_SET_WELCOME_MESSAGE,
  SESSION_FETCH_SUCCESS,
  SESSION_UPDATE_URL,
} = SessionActionTypes;

export const initialSessionState = {
  agentId: null,
  customerId: null,
  customerUrl: null,
  id: null,
  isAgentTyping: null,
  isSynced: null,
  lastMessage: null,
  localCreatedAt: null,
  metadata: null,
  unreadCount: 0,
  status: null,
  welcomeMessage: null,
};

export default function sessionReducer(state = initialSessionState, action) {
  const { record, type } = action;
  switch (type) {
    case SESSION_CREATE_ERROR:
      return {
        ...state,
        ready: false,
      };
    //   these are really handled by updates from Layer, so just blindly update
    case SESSION_FETCH_SUCCESS:
    case SESSION_CREATE_SUCCESS:
    case SESSION_UPDATE_SUCCESS:
      return {
        ...state,
        ...record,
      };
    case SESSION_SET_WELCOME_MESSAGE:
      return {
        ...state,
        welcomeMessage: record,
      };

    case SESSION_UPDATE_URL:
      return {
        ...state,
        customerUrl: record,
      };
    default:
      return state;
  }
}

export function sessionCreateSuccess(record) {
  return { type: SESSION_CREATE_SUCCESS, record };
}

export function sessionFetchSuccess(record) {
  return { type: SESSION_FETCH_SUCCESS, record };
}

export function sessionCreateError() {
  return { type: SESSION_CREATE_ERROR };
}

export function sessionUpdateSuccess(record) {
  return { type: SESSION_UPDATE_SUCCESS, record };
}

export function updateSessionUrl(record) {
  return { type: SESSION_UPDATE_URL, record };
}

export function setSessionWelcomeMessage(record) {
  return { type: SESSION_SET_WELCOME_MESSAGE, record };
}

export function updateCustomerTypingState(record) {
  return { type: CUSTOMER_TYPING_STATE_UPDATED, record };
}
/*
 * Thunk Actions
*/

/**
 * ensuring that if the widget does not receive a stop event we
 * transition isAgentTyping to false after 15 seconds
 */

export const checkCustomerUrlUpdated = () => {
  return (dispatch, getState) => {
    let session = getState().session;
    let trimmedUrl = getTrimmedUrl();
    if (!isDocumentHidden() && hasActiveSession(session) && session.customerUrl && session.customerUrl != trimmedUrl) {
      dispatch(updateSessionUrl(trimmedUrl));
    }
  };
};

/*
 * selectors
 */

export const hasActiveSession = session => !!session.id && !session.isEnded;
export const getSessionWelcomeMessage = session => session.welcomeMessage;
